import React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import qs from 'qs';
import {
  getPurchase,
  getPurchaseOrders,
  getPurchaseNotFound,
  getSub,
  getAttSub,
  getTracfoneSub,
  getSimoSub,
  getUser,
  getPurchaseLineItems,
  getPurchaseLineItemsCount,
  getIncludedInGroups,
  getLoggedInUser,
} from '../reducers';
import { getSubIdWithCarrierFromLineitem, getUniqSubs } from '../helpers/subs';

const withPurchase = (DecoratedComponent) => {
  let WithPurchase = ({ children, ...props }) => {
    return React.createElement(DecoratedComponent, props, children);
  };

  const mapStateToProps = (
    state,
    {
      match: {
        params: { purchaseId },
      },
      location: { search },
    },
  ) => {
    const purchase = getPurchase(state, purchaseId);
    const orders = getPurchaseOrders(state, purchaseId);
    const qsSearch = qs.parse(search, { ignoreQueryPrefix: true });
    const lineItemsPage = qsSearch?.lineItemsPage || 1;
    const lineItems = getPurchaseLineItems(state, purchaseId, lineItemsPage);
    const lineItemsCount = getPurchaseLineItemsCount(state, purchaseId);

    const {
      simo_subscription,
      att_subscription,
      subscription,
      mdn,
      ordering,
      icc_id,
    } = qsSearch;
    const filters = {
      att_subscription,
      simo_subscription,
      icc_id,
      subscription,
      mdn,
      ordering,
    };

    let subs = [];
    let user;

    if (purchase && lineItems) {
      subs = lineItems
        .map(getSubIdWithCarrierFromLineitem)
        .filter((sub) => sub.id);
      subs = getUniqSubs(subs);
      subs = subs
        .map((sub) => {
          if (sub.carrier === 'sprint') {
            return getSub(state, sub.id);
          } else if (sub.carrier === 'att') {
            return getAttSub(state, sub.id);
          } else if (sub.carrier === 'tracfone') {
            return getTracfoneSub(state, sub.id);
          } else if (sub.carrier === 'simo') {
            return getSimoSub(state, sub.id);
          } else {
            return null;
          }
        })
        .filter((sub) => sub);
      user = getUser(state, purchase.user_profile);
    }

    return {
      loggedInUser: getLoggedInUser(state),
      subs,
      purchase,
      orders,
      notFound: getPurchaseNotFound(state, purchaseId),
      purchaseId,
      user,
      lineItems,
      lineItemsPage,
      lineItemsCount,
      filters,
      qsSearch,
      isReseller: getIncludedInGroups(state, ['RESELLER']),
      isResellerOrAdminOrManager: getIncludedInGroups(state, [
        'RESELLER',
        'ADMIN',
        'MANAGER',
      ]),
    };
  };

  WithPurchase = withRouter(connect(mapStateToProps, null)(WithPurchase));

  const WithPurchaseRoute = ({ children, ...props }) => (
    <Route path="/purchases/:purchaseId" component={WithPurchase} {...props} />
  );

  return WithPurchaseRoute;
};

export default withPurchase;
